import { toastr } from 'react-redux-toastr';
import { ENDPOINTS } from '../constants';
import { apiGetPost } from '../apiHelpers';

export const apiDeleteAgreement = (
    AgreementHeaderId,
    notes,
    successTitle,
    successMessage,
    callback 
) => async dispatch => {
    const type = ENDPOINTS.API.AGREEMENT_DELETE;
    const data = {
        notes
    };

    dispatch(
        apiGetPost(
            type,
            ['agreement', 'delete', AgreementHeaderId],
            data,
            {},
            undefined,
            true,
            (dispatch, type, error) => {
                toastr.error('Delete Agreement', `${error.message}`);
            },
            undefined,
            successTitle,
            successMessage,
            callback
        )
    );
};
